import React from 'react';
import { Box } from '@mentimeter/ragnar-ui/box';
import { blue200 } from '@mentimeter/ragnar-colors';

export const ProgressBar = ({
  step: currentStep = 0,
  totalSteps,
}: {
  step: number;
  totalSteps: number;
}) => {
  const progress =
    totalSteps === 0 ? 0 : Math.max(0, Math.min(currentStep / totalSteps, 1));

  return (
    <Box
      height="4px"
      width="100%"
      bg="rgba(242, 241, 240, 0.15)"
      borderRadius="full"
    >
      <Box
        bg={blue200}
        height="4px"
        borderRadius="full"
        width={`${progress * 100}%`}
      />
    </Box>
  );
};
